import React from "react";
import { Navbar } from "react-bootstrap";
export default function Header(props) {
  return <Navbar id="header-nav" bg={'dark'} sticky={'top'} style={{width:"100%", margin:"0%", color:"yellow"}}>LE Enterprise Mapping</Navbar>;
}
